import React from 'react';
import { useParams } from 'react-router-dom';
import PFNominationPreview from './PFNominationPreview';
import FamilyDetailsPreview from './FamilyDetailsPreview';
import MarriageDeclarationPreview from './MarriageDeclarationPreview';
import RelationshipDeclarationPreview from './RelationshipDeclarationPreview';

export default function PreviewRenderer() {
  const { formCode } = useParams();

  switch (formCode) {
    case 'PF_NOM':
      return <PFNominationPreview />;
    case 'FAMILY':
      return <FamilyDetailsPreview />;
    case 'MARR_DECL':
      return <MarriageDeclarationPreview />;
    case 'REL_DECL':
      return <RelationshipDeclarationPreview />;
    default:
      return (
        <div className="max-w-4xl mx-auto px-6 py-8">
          <div className="flex items-center justify-center py-12">
            <div className="text-gray-500">Preview not found</div>
          </div>
        </div>
      );
  }
}
